import { render } from "./yc-fc3d.vue?vue&type=template&id=990ee472&scoped=true"
import script from "./yc-fc3d.vue?vue&type=script&lang=js"
export * from "./yc-fc3d.vue?vue&type=script&lang=js"

import "./yc-fc3d.vue?vue&type=style&index=0&id=990ee472&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990ee472"]])

export default __exports__